import { getSuggestionEventsSink } from "@/domain/suggestions";
import { getMerchantId } from "@/lib/company-storage";
import { useEffect } from "react";

/**
 * Starts the current merchant's suggestion-events sink (periodic flush +
 * hide/unload flush) once per app session. Mounted once in `HydratedShell`,
 * next to the other cross-cutting guards (`useCartTtlGuard` and friends).
 */
export function useSuggestionEventsFlush(): void {
  useEffect(() => {
    const merchantId = getMerchantId();
    if (!merchantId) return;
    return getSuggestionEventsSink(merchantId).start();
  }, []);
}
